<div class="wrapper">
  <app-project-preview-loading
    [show]="projectPreviewIsLoading$ | async"
    [text]="'The project is being loaded...'"
  ></app-project-preview-loading>
  <div class="content" *ngIf="!(projectPreviewIsLoading$ | async)">
    <div class="layout-3col">
      <!-- Left: Input files with text and media -->
      <div class="left input-files" *ngIf="inputFiles$ | async as inputFiles">
        <div style="margin: 12px auto; display: table; font-size: 14px">
          Input
        </div>
        <div class="input-file" *ngFor="let file of inputFiles">
          <ng-container *ngIf="contentOf(file) as c">
            <div class="if-text" *ngIf="c.text" [innerText]="c.text"></div>
            <div class="if-media" *ngIf="c.media?.length">
              <ng-container *ngFor="let m of c.media">
                <img
                  *ngIf="(m?.mimeType || m?.type || '').startsWith('image')"
                  class="if-thumb"
                  [src]="mediaUrl(m)"
                  alt="image"
                />
                <video
                  *ngIf="(m?.mimeType || m?.type || '').startsWith('video')"
                  class="if-thumb"
                  [src]="mediaUrl(m)"
                  muted
                  playsinline
                  controls
                ></video>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Middle: Canvas (centered vertically, no extra wrapper) -->
      <div class="middle">
        <nw-background-settings-modal
          *ngIf="showBgModal"
          [sceneIndexOptions]="sceneIndexOptions"
          [(startIndex)]="bgStartIndex"
          [(endIndex)]="bgEndIndex"
          [(type)]="bgType"
          (cancel)="closeBgModal()"
          (save)="onBgModalSave($event)"
        ></nw-background-settings-modal>

        <nw-layout-settings-modal
          *ngIf="showLayoutModal"
          [sceneIndexOptions]="sceneIndexOptions"
          [(startIndex)]="layoutStartIndex"
          [(endIndex)]="layoutEndIndex"
          [(type)]="layoutType"
          [(baseMargin)]="layoutBaseMargin"
          (cancel)="closeLayoutModal()"
          (save)="setLayout($event)"
        ></nw-layout-settings-modal>

        <nw-text-edit-modal
          *ngIf="textEditModalConfig"
          [id]="textEditModalConfig.id"
          [value]="textEditModalConfig.text"
          (cancel)="textEditModalConfig = null"
          (saveFull)="onTextModalSaveFull($event)"
        ></nw-text-edit-modal>

        <nw-image-upload-modal
          *ngIf="showImageUploadModal"
          (cancel)="closeImageUploadModal()"
          (upload)="onImageUpload($event)"
        ></nw-image-upload-modal>

        <div style="width: -webkit-fill-available">
          <iw-canvas></iw-canvas>
          <nw-video-controls></nw-video-controls>
          <!-- <nw-video-edit-prompt></nw-video-edit-prompt> -->
        </div>
        <div>
          <div>Project</div>
          <div class="flex-row gap-4">
            <nw-file-project-settings
              label="Complete"
              [completeProject]="true"
            ></nw-file-project-settings>
            <nw-file-project-settings
              label="Background"
              [projectKey]="'backgroundDefinitions'"
            ></nw-file-project-settings>
          </div>
          <div>Scene</div>
          <div class="flex-row gap-4">
            <nw-file-project-settings
              label="Complete"
              [completeFile]="true"
            ></nw-file-project-settings>
            <nw-file-project-settings
              label="Animations"
              [fileKey]="'textAnimationStep'"
            ></nw-file-project-settings>
            <nw-file-project-settings
              label="Content"
              [fileKey]="'content'"
            ></nw-file-project-settings>

            <nw-text-animation-editor></nw-text-animation-editor>
          </div>
        </div>

        <!-- <nw-video-setting-tabs></nw-video-setting-tabs> -->
      </div>

      <!-- Right: Slide viewer (vertical) -->
      <div class="right slides-vertical canvas-wrap">
        <div style="margin: 12px auto 10px; display: table; font-size: 14px">
          Scenes
        </div>
        <nw-slide-viewer></nw-slide-viewer>
      </div>
    </div>
  </div>
</div>
